export default __webpack_public_path__ + "static/media/pic_ai_4.7996d55f.png";